import { Application } from './Application';
import { Customer, UserProfile } from './Customer';

export type AllowToEdit = 'N' | 'Y';
export type PowerUser = 'N' | 'Y';
export type Role = string; // todo

export interface TokenResponse {
  applications: Application[];
  country: string;
  customer: Customer;
  customerId: number;
  edit: AllowToEdit;
  jwt: string;
  oauth2: OAuth2;
  powerUser: PowerUser;
  profile: UserProfile;
  role: Role;
  sessionId: number;
}

export interface OAuth2 {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  scope: string;
}
export interface TokenRefreshResponse extends OAuth2 {
  token_type: string;
}
